import script from "./StepCircles.vue?vue&type=script&setup=true&lang=js"
export * from "./StepCircles.vue?vue&type=script&setup=true&lang=js"

import "./StepCircles.vue?vue&type=style&index=0&id=498956ce&scoped=true&lang=css"

import exportComponent from "/builds/sense/sense-signer/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-498956ce"]])

export default __exports__